import { useNavigate, useParams, NavigateOptions, To } from "react-router-dom";

export const useAppNavigate = () => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || localStorage.getItem("i18nextLng") || "en";

  return (to: To | number, options?: NavigateOptions) => {
    // Якщо передали цифру (наприклад, -1 для кроку назад)
    if (typeof to === "number") {
      navigate(to);
      return;
    }

    let localizedTo = to as string;

    if (typeof to === "string" && to.startsWith("/")) {
      const hasLangPrefix = /^\/[a-z]{2}(\/|$)/.test(to);
      if (!hasLangPrefix) {
        localizedTo = to === "/" ? `/${currentLang}` : `/${currentLang}${to}`;
      }
    }

    navigate(localizedTo, options);
  };
};
